import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { ASSETS } from "../../../../utils/config";

function SelectionButtons({
  selectedView,
  isBBoxExist,
  isMediaExist,
  onButtonClick = () => {},
}) {
  const disableColor = "rgba(187, 187, 187, 1)";

  return (
    <Stack
      display={"flex"}
      flexDirection={"row"}
      //   justifyContent={"space-evenly"}
      sx={{
        border: "0.5px solid #BBBBBB",
        backgroundColor: "#F6F7F9",
        p: 0.4,
        borderRadius: "4px",
        height: "40px",
        ml: "3vw",
        mr: "28vw",
        position: "relative",
      }}
    >
      <Box
        onClick={() => onButtonClick(0)}
        sx={{
          backgroundColor:
            isBBoxExist && selectedView === 0 ? "#123051" : "#F6F7F9",
          height: "32px",
          cursor: "pointer",

          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
        }}
      >
        {/* <img
          src={ASSETS.businessbox}
          alt="bbox"
          style={{ height: "5vh", width: "5vw" }}
        /> */}
        <Typography
          onClick={() => onButtonClick(0)}
          sx={{
            fontFamily: "DM Sans",
            cursor: "pointer",
            fontWeight: "500",
            textTransform: "capitalize",
            color: isBBoxExist && selectedView === 0 ? "white" : "#BBBBBB",
          }}
        >
          Business Box
        </Typography>
      </Box>
      <Box
        onClick={() => onButtonClick(1)}
        sx={{
          backgroundColor: !isMediaExist
            ? disableColor
            : selectedView === 1
            ? "#123051"
            : "#F6F7F9",
          height: "32px",
          cursor: "pointer",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
        }}
      >
        {/* <img
          src={ASSETS.mediaSidebarIcon}
          alt="media"
          style={{ height: "7vh", width: "7vw" }}
        /> */}
        <Typography
          onClick={() => onButtonClick(1)}
          sx={{
            fontFamily: "DM Sans",
            cursor: "pointer",
            fontWeight: "500",
            textTransform: "capitalize",
            color: selectedView === 1 && isMediaExist ? "white" : "#BBBBBB",
          }}
        >
          Media
        </Typography>
      </Box>
    </Stack>
  );
}

export default SelectionButtons;
